const STORAGE_KEY = 'ArbolEc_pendingDelete'
const TTL_MS = 10 * 60 * 1000 // ventana del OTP (~10 min)

/**
 * Slot único en sessionStorage para recordar un borrado con OTP en curso, de
 * modo que tras una recarga de página se pueda reabrir el modal "Verificar
 * eliminación" y pegar el código ya enviado al correo.
 *
 * @typedef {{ table: string, id: (string|number), label: string }} PendingDelete
 */

export const setPendingDelete = ({ table, id, label }) => {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ table, id, label, ts: Date.now() }),
    )
  } catch {
    /* cuota: se ignora */
  }
}

export const getPendingDelete = table => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null

    const data = JSON.parse(raw)
    if (!data?.table || data.id == null) return null

    if (Date.now() - (data.ts || 0) > TTL_MS) {
      sessionStorage.removeItem(STORAGE_KEY)
      return null
    }

    if (table && data.table !== table) return null

    return { table: data.table, id: data.id, label: data.label }
  } catch {
    return null
  }
}

export const clearPendingDelete = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
}
